import { configureStore } from '@reduxjs/toolkit'

import accountSilce from './actions/account'
import paymentsSilce from './actions/payments'

export default configureStore({
  reducer: {
    accounts: accountSilce,
    payments: paymentsSilce
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
        serializableCheck: false
    }),
})